// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

type Props = WidgetProps & HasCategoryContext;

export interface CartTitleStyles {
    container?: InjectableCss;
    titleWrapper?: InjectableCss;
    pageTitle?: TypographyProps;
    itemCountText?: TypographyProps;
}

export const cartTitleStyles: CartTitleStyles = {};

const styles = cartTitleStyles;
export const CartTitle = () => {
    const { cart, pageTitle } = useAppSelector(state => {
        return {
            cart: getCurrentCartState(state).value,
            pageTitle: getCurrentPage(state).fields.title,
        };
    });

    const totalItemCount = cart?.cartLines?.length || 0;
    return (
        <StyledWrapper {...styles.container}>
            <Typography {...styles.pageTitle}>{pageTitle}</Typography>
            {totalItemCount > 0 && (
                <Typography className="items-count-wrapper" {...styles.itemCountText}>{`${totalItemCount} ${translate(
                    "Products",
                )}`}</Typography>
            )}
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: CartTitle,
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        displayName: "Cart Title And Count",
    },
};
export default widgetModule;
